import { Component, OnInit, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { EpbtFaQuickTransferService } from '../../services/epbt-fa-quick-transfer.service';
import { EpbtFaQuickTransferLineModel } from '../../models/epbt-fa-quick-transfer-line-model';
import { TallyEntryLineModel } from '../../models/tally-entry-line.model';
import { EpbtFaTallyModel } from '../../models/epbt-fa-tally.model';
import { EpButtonType, EpButtonStyle, IEpGridModel, IEpGridColumn, IEpGridEditState, EpGridEditMode, IEpColumnNumericFormat, EpGridComponent } from '@epicor/kinetic';
import { ProductPrice } from 'ep-bt-field-agent-proxy';
import { Router } from '@angular/router';
import { Location } from '@angular/common';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-product-tallied-quantity-control',
  templateUrl: './epbt-fa-product-tallied-quantity-control.component.html',
  styleUrls: ['./epbt-fa-product-tallied-quantity-control.component.scss']
})
export class EpbtFaProductTalliedQuantityControlComponent implements OnInit, AfterViewInit {

  selectedQuickTransferLine: EpbtFaQuickTransferLineModel;
  quickTransferTalliedLines: TallyEntryLineModel[];
  oldQuickTransferTalliedLines: any[];
  EpButtonStyle = EpButtonStyle;
  EpButtonType = EpButtonType;
  constructor(private fb: FormBuilder, private location: Location, private quickTransferService: EpbtFaQuickTransferService, private route: Router) { }

  // buttonModel: IEpButtonModel = {
  //   type: EpButtonType.Submit
  // }
  // tallyForm: FormGroup
  tallyGridModel: IEpGridModel;
  // @ViewChild('tallyQuantityDisplay', {static: false}) tallyQuantityDisplay: TemplateRef<any>;
  @ViewChild('tallyLengthDisplay', {static: false}) tallyLengthDisplay: TemplateRef<any>;
  @ViewChild(EpGridComponent, {static: false}) tallyGrid: EpGridComponent;

  // editOptions: IEpGridColumnEditOptions={
  //   numberFormat: IEpColumnNumericFormat = {

  //   }
  // }

  // get tallies() {
  //   return this.tallyForm.get('tallies') as FormArray;
  // }

  numberFormat: IEpColumnNumericFormat = {
    max: 99999, min: 0, allowNegative: false, decimals: 0
  };

  ngOnInit() {
    // this.tallyForm = this.fb.group({
    //   tallies: this.fb.array([])
    // });
    this.LoadQuickTransferLineData();
    this.tallyGridModel = this.gettallyGridModel();
  }


  ngAfterViewInit() {
    this.tallyGridModel.columns[1].editOptions.numberFormat = this.numberFormat;
  }
  // createQuantity(element): FormGroup {
  //   return this.fb.group({
  //     quantity: element.Quantity
  //   });
  // }

  // addItem(): void {
  //   this.items = this.orderForm.get('items') as FormArray;
  //   this.items.push(this.createItem());
  // }

  LoadQuickTransferLineData() {
    if (this.quickTransferService.quickTransfer.quickTransferLines) {
      this.selectedQuickTransferLine = this.quickTransferService.quickTransfer.quickTransferLines.find(item => item.lineNumber == this.quickTransferService.quickTransfer.selectedLineIndex);
      if (this.selectedQuickTransferLine) {
        this.quickTransferTalliedLines = this.selectedQuickTransferLine.tallyEntryLines;
        this.setOldTallies();
      }
      console.log(this.quickTransferTalliedLines, 'tally Lines');
    }
  }

  setOldTallies() {
    this.oldQuickTransferTalliedLines = [];
    this.selectedQuickTransferLine.tallyEntryLines.forEach(element => {
      const line = {
        id: element.ID,
        qty: element.Quantity
      };
      this.oldQuickTransferTalliedLines.push(line);
    });
  }

  getOldTallies() {
    this.selectedQuickTransferLine.tallyEntryLines.forEach(element => {
      const line = this.oldQuickTransferTalliedLines.find(l => l.id == element.ID);
      if (line) { element.Quantity = line.qty; }
    });
  }

  onTallySubmit() {
    if (this.checkMaxQuantityLimit()) {
      this.selectedQuickTransferLine.tallyCustom = new EpbtFaTallyModel();
      this.selectedQuickTransferLine.isSave = true;
      this.quickTransferTalliedLines.forEach(element => {
        element.Quantity = element.Quantity ? element.Quantity : 0;
        this.selectedQuickTransferLine.tallyCustom.add(element.Quantity.toString(), element.Length.toString());
      });

      this.selectedQuickTransferLine.quantity = this.selectedQuickTransferLine.tallyCustom.totalTallyLength;
      this.selectedQuickTransferLine.quantityTally = this.selectedQuickTransferLine.tallyCustom.tallyString;

      if (this.selectedQuickTransferLine.checkTallyProduct(this.selectedQuickTransferLine.product.tallyLengths) && this.selectedQuickTransferLine.tallyCustom != null) {
        // Update line/tally totals
        this.quickTransferService.updateLineTotals(this.selectedQuickTransferLine);
        console.log(this.selectedQuickTransferLine, 'tallied tally1');

        // Set to product inputPer
        this.selectedQuickTransferLine.inputPer = this.selectedQuickTransferLine.product.inputPer;
        this.selectedQuickTransferLine.per = this.selectedQuickTransferLine.inputPer;
        // this.selectedQuickTransferLine.adding = false;
      } else {
        // tallied product w/o tally?
      }
      console.log(this.selectedQuickTransferLine, 'tallied tally1');
      this.route.navigate(['/home/quicktransfer']);
    }
  }

  checkMaxQuantityLimit(): boolean {
    let flag = true;
    this.quickTransferTalliedLines.forEach(element => {
      if (element.Quantity > 999999) {
        flag = false;
      }
    });
    return flag;
  }

  // grid code

  gettallyGridModel(): IEpGridModel {
    // const selectionOptions: IEpGridSelectionOptions = {
    //   selectByField: "customerContactID",
    //   selectedKeys: [],
    // };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: true,
      groupable: false,
      filterable: false,
      editable: true,
      editOptions: {
        defaultEditable: true,
        editMode: EpGridEditMode.cell,
        updateOnChange: true,

        // validation on end of edit
        // fnValidate: (editState: IEpGridEditState) => {
        //   const len = (editState.dataEdit['Quantity'] + '').;
        //   if (len < 3) {
        //     //alert('Name must consist of at least 3 characters');
        //   }
        //   return len >= 3;
        // }

        // validation on change of value
        onChangeValidate: (column: IEpGridColumn, newValue: any, originalValue: any, state: IEpGridEditState) => {
          if (column.field === 'Quantity' && newValue < 0) {
            return false;
          }
          if (column.field === 'Quantity' && (newValue % 1) > 0) {
            // let num = newValue % 1;
            return false;
          }
          return true;
        }
      },
      // pageable: true,
      // pageSize: 10,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      // selectionOptions: selectionOptions,
      data: this.quickTransferTalliedLines,
      columns: [
        { field: 'Length', title: 'Length', width: 100, hidden: false, editable: false, cellTemplate: this.tallyLengthDisplay },
        { field: 'Quantity', title: 'Quantity', width: 60, hidden: false, class: 'color-blue', editable: true, editor: 'numeric' },
      ]
    };
    return model;
  }

  onTallyCancel() {
    if (!this.quickTransferService.isNegotiationEdit) {
      const index = this.quickTransferService.quickTransfer.quickTransferLines.findIndex(item => item.lineNumber == this.quickTransferService.quickTransfer.selectedLineIndex);
      if (index >= 0) {
        this.quickTransferService.quickTransfer.quickTransferLines.splice(index, 1);
      }
    } else {
      this.getOldTallies();
    }
    this.route.navigate(['/home/quicktransfer']);
  }

  // onTallyChange(event: any) {
  //   console.log(event, "tally event")
  //   this.quickTransferTalliedLines.forEach(element => {
  //     if (element.ID == event.target.id) {
  //       element.Quantity = event.data;
  //     }
  //   });
  // }
}
